import React from 'react';
import './scss/FooterComponent.scss';

export default function FooterComponent() {
    return (
        <footer id="footer">
            <p>&copy;Seon Jong Moon. All Rights Reserved.</p>
        </footer>
    );
}